export default __webpack_public_path__ + "static/media/resolutionImg.73add855.webp";